export interface IWarehouseShopOrderNoteData {
    id: number;
    product?: null|number|string;
    timestamp: string;
    user: string;
    type: string;
    description: string;
}

export default class WarehouseShopOrderNoteData {
    public id: number;
    public product: null|number;
    public timestamp: string;
    public user: string;
    public type: string;
    public description: string;

    constructor(data: IWarehouseShopOrderNoteData) {
        this.id = Number(data.id);
        this.product = data.product === null || data.product === undefined
            ? null
            : Number(data.product);
        this.timestamp = data.timestamp;
        this.user = data.user;
        this.type = data.type;
        this.description = data.description;
    }
}